import { get } from 'lodash';
import { TicketInterface } from '../types/app';

/**
 * Checks if a ticket is currently assigned to a customer.
 * A ticket is considered assigned if:
 * 1. It has a customer assigned to it (ticketAssign.customer.id exists)
 * 2. The assignment has not been revoked (ticketAssign.revokedDate is null/undefined)
 *
 * @param ticket - The ticket to check
 * @returns true if the ticket is assigned and not revoked, false otherwise
 */
export const isTicketAssigned = (ticket: TicketInterface): boolean =>
  !!get(ticket, 'ticketAssign.customer.id') && !get(ticket, 'ticketAssign.revokedDate', null);

/**
 * Checks if the purchaser is viewing a ticket they assigned to someone else.
 * This is used to determine if barcode should be suppressed.
 *
 * @param ticket - The ticket to check
 * @param isViewingAsAssignee - Whether the current viewer is the assignee
 * @returns true if ticket is assigned and viewer is not the assignee (i.e., purchaser viewing assigned ticket)
 */
export const checkPurchaserViewingAssignedTicket = (ticket: TicketInterface, isViewingAsAssignee: boolean): boolean =>
  isTicketAssigned(ticket) && !isViewingAsAssignee;
